import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * What an area holds when it holds nothing (yet): what will be here and, for areas without a
 * backend, that it is not available yet. Never sample rows.
 */
export function EmptyState(props: {
  icon: LucideIcon;
  title: string;
  children: ReactNode;
  status?: string;
  action?: ReactNode;
  headingLevel?: 1 | 2 | 3;
  className?: string;
}) {
  const Icon = props.icon;
  const Heading = `h${props.headingLevel ?? 2}` as "h2";
  return (
    <div className={cn("flex max-w-md flex-col items-start gap-3", props.className)}>
      <span className="grid size-10 place-items-center rounded-lg border border-line bg-surface-raised text-fg-muted shadow-xs">
        <Icon aria-hidden="true" className="size-5" strokeWidth={1.5} />
      </span>
      <div className="flex flex-col gap-1.5">
        <Heading className="text-base font-semibold text-fg">{props.title}</Heading>
        <p className="text-sm leading-relaxed text-fg-secondary">{props.children}</p>
      </div>
      {props.status ? (
        <p className="inline-flex items-center gap-1.5 text-xs font-medium text-fg-muted">
          <span aria-hidden="true" className="size-1.5 rounded-full bg-line-strong" />
          {props.status}
        </p>
      ) : null}
      {props.action}
    </div>
  );
}
